package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

// COPY RULE: no user-facing English here. Callers pass localized [message] and a11y labels.

/**
 * App-wide notice banner (e.g. the graceful-sunset message). A leading warning glyph, the localized
 * [message], and an optional dismiss button when [onDismiss] is set. Neutral high-surface fill with a
 * saffron icon so it reads as an announcement, not an error — legible in light and dark, RTL-safe
 * (start/end). [dismissContentDescription] is the localized a11y label for the close button.
 */
@Composable
fun AppBanner(
    message: String,
    modifier: Modifier = Modifier,
    iconName: String = "warning",
    onDismiss: (() -> Unit)? = null,
    dismissContentDescription: String? = null,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surfaceContainerHigh)
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        AppIcon(
            name = iconName,
            size = AppTheme.sizes.iconMd,
            tint = AppTheme.colors.secondary,
        )
        Text(
            text = message,
            style = AppTheme.typography.bodySm,
            color = AppTheme.colors.onSurface,
            modifier = Modifier.weight(1f),
        )
        if (onDismiss != null && dismissContentDescription != null) {
            AppIconButton(
                iconName = "close",
                contentDescription = dismissContentDescription,
                onClick = onDismiss,
                tint = AppTheme.colors.onSurfaceVariant,
            )
        }
    }
}

@Preview
@Composable
private fun AppBannerPreview() {
    AppTheme {
        AppBanner(
            message = "Mahaleh is winding down. You can still browse, but new purchases are paused.",
            onDismiss = {},
            dismissContentDescription = "Dismiss",
        )
    }
}
